import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Cell } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface AiAdoptionChartProps {
  data: Array<{
    stage: string;
    count: number;
    percentage: number;
  }>;
}

// Theme-aware colors for AI adoption stages
const getStageColors = () => ({
  exploring: 'hsl(var(--muted-foreground))',    // gray - not started
  piloting: 'hsl(var(--primary))',              // primary color - early stage
  implementing: 'hsl(var(--chart-secondary, #8b5cf6))', // purple - active
  scaling: 'hsl(var(--chart-accent, #f97316))',     // orange - expanding
  mature: 'hsl(var(--chart-success, #22c55e))',      // green - advanced
});

export function AiAdoptionChart({ data }: AiAdoptionChartProps) {
  const stageColors = getStageColors();

  const chartData = data.map((item) => ({
    stage: item.stage,
    count: item.count,
    percentage: item.percentage,
    displayName: item.stage.charAt(0).toUpperCase() + item.stage.slice(1),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>AI Adoption Stage</CardTitle>
        <CardDescription>Companies by AI adoption stage</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <XAxis type="number" hide />
            <YAxis
              type="category"
              dataKey="displayName"
              width={100}
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              formatter={(value: any) => `${value} companies`} // eslint-disable-line @typescript-eslint/no-explicit-any
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '6px',
                color: 'hsl(var(--foreground))',
              }}
            />
            <Bar dataKey="count" radius={[0, 8, 8, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={stageColors[entry.stage as keyof typeof stageColors] || 'hsl(var(--primary))'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
